module.exports = __webpack_public_path__ + "static/img/Noer Fajrin-close.58593ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Noer Fajrin-close.jpg
// module id = J2cC
// module chunks = 1